<h4>{{i18n.get('orders_order_nr_label', 'orders')}} {{order.ordernr}}</h4>
<div class="mt-3 mb-3">
  <div *ngIf="this.orderDetails" class="row">
    <div class="col-md-6">
      <dl>
        <dt>{{i18n.get('orders_created_on_label', 'orders')}}</dt>
        <dd>{{getFormattedDate(order.orderdate)}} by <u>{{order.username}} ({{order.useremail}})</u></dd>
        <dt *ngIf="this.orderDetails.options.comments">{{i18n.get('global_comments')}}</dt>
        <dd *ngIf="this.orderDetails.options.comments">
          {{this.orderDetails.options.comments}}
        </dd>
        <!-- TODO: Show order form options -->
      </dl>
    </div>
    <div class="col-md-6">
      <dl>
        <dt>{{i18n.get('global_company_label')}}</dt>
        <dd>
          <span *ngIf="this.orderDetails.options.deliveryAddress.deliveryAddressArray.companyName">{{this.orderDetails.options.deliveryAddress.deliveryAddressArray.companyName}}</span><br>
          <span *ngIf="this.orderDetails.options.deliveryAddress.deliveryAddressArray.department">{{this.orderDetails.options.deliveryAddress.deliveryAddressArray.department}}<br></span>
          <span
            *ngIf="this.orderDetails.options.deliveryAddress.deliveryAddressArray.addressLine1">{{this.orderDetails.options.deliveryAddress.deliveryAddressArray.addressLine1}}
            <br></span>
          <span *ngIf="this.orderDetails.options.deliveryAddress.deliveryAddressArray.addressLine2">{{this.orderDetails.options.deliveryAddress.deliveryAddressArray.addressLine2}}
            <br></span>
          <span
            *ngIf="this.orderDetails.options.deliveryAddress.deliveryAddressArray.city &&
            this.orderDetails.options.deliveryAddress.deliveryAddressArray.zip">{{this.orderDetails.options.deliveryAddress.deliveryAddressArray.zip}} {{this.orderDetails.options.deliveryAddress.deliveryAddressArray.city}}
            <br></span>
          <span *ngIf="this.orderDetails.options.deliveryAddress.deliveryAddressArray.country">{{this.orderDetails.options.deliveryAddress.deliveryAddressArray.country}}<br></span>
          <span *ngIf="this.orderDetails.options.deliveryAddress.deliveryAddressArray.phone"><i class="fas fa-sm fa-phone"></i> {{this.orderDetails.options.deliveryAddress.deliveryAddressArray.phone}}
            <br></span>
          <span *ngIf="this.orderDetails.options.deliveryAddress.deliveryAddressArray.email"><i class="fas fa-sm fa-at"></i> {{this.orderDetails.options.deliveryAddress.deliveryAddressArray.email}}</span>
        </dd>
        <dt *ngIf="this.orderDetails.options.deliveryAddress.deliveryAddressArray.comments">{{i18n.get('global_comments')}}</dt>
        <dd *ngIf="this.orderDetails.options.deliveryAddress.deliveryAddressArray.comments">
          {{this.orderDetails.options.deliveryAddress.deliveryAddressArray.comments}}
        </dd>
      </dl>
    </div>
  </div>
  <div class="row">
    <div *ngIf="!documentLists" class="alert text-center mt-1" role="alert">
      <i class="fa-spin fas fa-sync me-2"></i>
    </div>
    <div *ngIf="documentLists" class="col-12">

      <!-- Display document types lists -->
      <app-order-document-list *ngFor="let documentTypeKey of getDocumentTypeKeys()"
                               [displayFields]="documentLists[documentTypeKey].displayFields"
                               [documents]="documentLists[documentTypeKey].documents"
                               [documentTypeLabel]="documentLists[documentTypeKey].documentTypeLabel">

      </app-order-document-list>

    </div>
  </div>
</div>
<!--
<pre><code>{{ order | json }}</code></pre>
<pre><code>{{ decodedOrderData | json }}</code></pre>
<pre><code>{{ decodedOrderAddressFields | json }}</code></pre>
-->
